import { Component, Input, OnInit, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit } from '@angular/core'
import { Field, Type, Filter } from '../../../model/selector'
import { Collection } from '../../../model/collection'
import { Observable } from 'rxjs/Observable'
import { fromEvent } from 'rxjs'
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import { ViewService, SelectorService } from '../../../shared'
import { Array } from 'core-js'
// import { Filters } from '../../../model/mock-data'

declare var $: any;

@Component({
    selector: 'field',
    template: require('./list-item.html'),
    styles: [require('./selector-list-item.scss'), require('../list.component.scss'), require('../../../app.component.scss')]
})

export class SelectorListItemComponent implements OnInit, AfterViewInit {
    @Input() fieldID = -1;
    @Output() addDetailsEvent = new EventEmitter();
    @Output() deleteSelector = new EventEmitter();
    @Output() cssChanged = new EventEmitter();
    @Output() editCss = new EventEmitter();
    @Output() pathSelected = new EventEmitter();

    @ViewChild('zpanel') expand_panel;
    @ViewChild('filtermenu') filterMenu: ElementRef;

    @Input() field: Field = null;
    private selected = false;
    private expanded = false;
    private selector_panel_id = 'selector-panel-';
    private regexValue = '';
    Filters = [
        { name: ['Trim'], checked: true },
        { name: ['Normal', 'UPPERCASE', 'lowercase', 'Capitalize']},
        { name: ['Concatinate'], checked: false }
    ];
    FieldAttrs = [
        ['src', 'alt'],
        ['text'],
        ['href', 'text']
    ]
/*
    link_extractors: Array<Array<Object>> = [
        [
            {name: 'src', extractor: {type: 'attr', params: {attr: 'src', includeIfEmpty: false}, fieldMapValue: 0}},
            {name: 'alt', extractor: {type: 'attr', params: {attr: 'alt', includeIfEmpty: false}, fieldMapValue: 0}}
        ],
        [
        //    {name: 'text', extractor: {type: 'text', params: {includeIfEmpty: false}, fieldMapValue: 1}},
            {name: 'regex', extractor: {type: 'regex', params: {regexp: '', includeIfEmpty: false}, fieldMapValue: 1}}
        ],
        [
            {name: 'text', extractor: {type: 'text', params: {includeIfEmpty: false}, fieldMapValue: 1}},
            {name: 'href', extractor: {type: 'attr', params: {attr: 'href', includeIfEmpty: false}, fieldMapValue: 1}}
        ]
    ];
*/
    constructor(private _selectorService: SelectorService, private viewService: ViewService) {
    }

    onCSSSelectorChange() {
        // this.cssChanged.emit();
        this._selectorService.setSelectorPath(this.field);
    }

    ngOnInit() {
        this.selector_panel_id += this.fieldID;
        let regexIndex = this.field.filterIndex('regex');
        if (regexIndex !== -1) {
            this.regexValue = this.field.filters[regexIndex].param;
        }
    }

    updateExtractor(event) {
        // this.selector.extractor = event;
    }

    addDetails() {
        if (this.field.details == null) {
            let url: string = this._selectorService.getElemAttr(this.field.selector, 'href');
            if (url.search('^http(s)?') === -1) {
                let base = this._selectorService.getElemAttr('base', 'href');
                url = this._selectorService.absolute(base, url);
            }
            if (url.length > 0) {
                this.field.details = new Collection(this.field.name + 'details',
                 {'url': url, 'userToken': '', 'type': '', actions: [], proxy: ''},
                 []);
            }
        }
        this.addDetailsEvent.emit(this.field.details);
    }

    onDelete() {
        this.deleteSelector.emit(this.fieldID)
    }

    ngAfterViewInit() {
        let filterStream = fromEvent(this.filterMenu.nativeElement, 'click').subscribe(
            e =>  this.fillExtractorfilter());
    }

    fillExtractorfilter() {
        this.field.filters = [];
        let self = this;
        $('#filters_' + this.fieldID + '>li>input').each(function() {
            if ($(this).prop('checked') === true && $(this).attr('value') !== 'normal') {
                let filterName = $(this).attr('value');
                self.field.filters.push(new Filter(filterName, (filterName === 'regex') ? self.regexValue : ''));
            }
        });
    }

    onRegexChange() {
        if (this.regexValue === '') {
            return;
        }
        let regexIndex = this.field.filterIndex('regex');
        if (regexIndex !== -1) {
            this.field.filters[regexIndex].param = this.regexValue;
        } else {
            this.field.filters.push(new Filter('regex', this.regexValue));
        }
        this._selectorService.setSelectorPath(this.field);
    }

    onclickExtractor(attrName: string, add: boolean) {
        if (this.field.type === Type.Text) {
            return;
        }
        try {
            if (attrName === 'path' && add) {
                this.pathSelected.emit(true);
            } else {
                this.pathSelected.emit(false);
            }
            this.field.updateAttrs(attrName, add);

        } catch (e) {
            this.viewService.errorAlert((<Error>e).message);
    }

 /*       let self = this;
        this.selector.extractor.type = '';
        $('#extractor_' + this.selector_id + '>label>input').each(function() {
            if ($(this).prop('checked') && self.selector.type !== Type.Text) {
                if (this.selector.extractor.type === '') {
                    if ($(this).attr('value') === 'text') {
                        self.selector.extractor.type = $(this).attr('value');
                    } else {
                        self.selector.extractor.type = 'attr';
                        self.selector.extractor.params = {attr: $(this).attr('value'), includeIfEmpty: false}
                    }
                } else {
                    if (self.selector.type = Type.Image) {
                        self.selector.extractor.type = 'image';
                    } else {
                        self.selector.extractor.type = 'link';
                    }
                }
            } else {
                if ($(this).prop('checked')) {
                    self.selector.extractor.type = 'regex';
                }
            }
        });
        console.log(this.selector.extractor);*/
    }

    toggleType() {
        this.field.toggleType();
    }
}
